import { history } from '@edge/spark/utils'

interface LinkParameters {
    year_week: string
}

interface Link {
    parameters: LinkParameters
}

const linkOptions = {
    events: {
        click: (_evt: unknown, link: Link): void => {
            const query = new URLSearchParams(window.location.search)
            query.set('report', `salesWeekDetail`)
            query.set('yearWeek', `${link.parameters.year_week}`)
            history.push({ search: query.toString() })
        },
    },
}

export default linkOptions
